/* eslint-disable import/no-cycle */
import Banner from './BannerFullWidth'
import CustomBanner from './CustomBanner'
import Pill from './Pill'
import Title from './Title'
import Paragraph from './Paragraph'
import BodyText from './BodyText'
import Hero from './Hero'
import Header from './Header'
import Image from './Image'
import Cards from './Cards'
import Grid from './Grid'
import Container from './Container'
import ImageTextContFull from './ImageTextContFull'
import ImageTextCont from './ImageTextCont'
import Spacer from './Spacer'
import Result from './Result'
import Coupon from './Coupon'
import BtnLink from './BtnLink'
import FootNote from './FootNote'
import LandingFooter from './Footer'
import VideoFullWidth from './VideoFullWidth'
import StepsSection from './StepsSection'
import Video from './Video'

export default {
  Banner,
  CustomBanner,
  Pill,
  Title,
  Paragraph,
  BodyText,
  Hero,
  Header,
  Image,
  Cards,
  Container,
  ImageTextContFull,
  ImageTextCont,
  Grid,
  Spacer,
  Result,
  Coupon,
  BtnLink,
  FootNote,
  LandingFooter,
  VideoFullWidth,
  StepsSection,
  Video,
}
